import cn from 'classnames'
import type {ReactNode} from 'react'

export type ContentCardProps = {
  children: ReactNode
  row?: boolean
  className?: string
}

export const ContentCard = ({children, row = false, className}: ContentCardProps) => (
  <div
    className={cn(
      'flex min-w-[140px] flex-1 basis-[140px] rounded-card border border-moss-white/10 bg-moss-white/[2%] p-6 sm:min-w-[200px] sm:basis-[200px]',
      row ? 'flex-row items-center gap-3' : 'flex-col',
      className,
    )}
  >
    {children}
  </div>
)
